import { Left } from './Left'
import { Middle } from './Middle'
import { Right } from './Right'
import { fieldSetModel } from "../fieldSetModel";
import '../fieldSet.less'
import { useEffect } from 'react';

export const FieldSet = () => {

    const { selectedSettle, selectedFranchisee, getSettleDict, getFranchisee } = fieldSetModel()
    useEffect(() => {
        getSettleDict();
    getFranchisee();
    }, [])

    return (
        <>
            <div className="container">
                <div className="left">
                    <Left />
                </div>
                <div className="child middle">
                    <Middle />
                </div>
                <div className="child right">
                    {selectedSettle && selectedFranchisee && <Right />}
                </div>
            </div >
        </>
    )
}